import { Route } from 'react-router-dom';

import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard';

import ConnectedUsers from './ConnectedUsers';
import Card from './Card/Card';

export const ConnectedUsersRoutes = () => [
  <Route
    path="/monitoring/connected-users"
    element={
      <RouteGuard requiredRoles={['connected_devices']}>
        <ConnectedUsers />
      </RouteGuard>
    }
    key={'connected-users'}
  >
    <Route path={':id'} element={<Card />} />
  </Route>
];

export default ConnectedUsersRoutes;